module.exports = __webpack_public_path__ + "img/features_1.ddf2e878.png";